import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row gy-5 gx-xl-8 pb-5" }
const _hoisted_2 = { class: "col-xxl-8" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-header border-0 pt-5" }
const _hoisted_5 = { class: "card-title align-items-start flex-column" }
const _hoisted_6 = { class: "card-label fw-bolder fs-3 mb-1" }
const _hoisted_7 = { class: "card-toolbar" }
const _hoisted_8 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_9 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "card-body py-3" }
const _hoisted_12 = { class: "row g-9 mb-8" }
const _hoisted_13 = { class: "col-md-3 fv-row" }
const _hoisted_14 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_15 = {
  key: 0,
  class: "col-md-3 fv-row"
}
const _hoisted_16 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_17 = {
  key: 0,
  class: "d-flex justify-content-center mt-15"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border spinner-lg",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_21 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4" }
const _hoisted_22 = { class: "fw-bolder text-muted" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_24 = { class: "min-w-200px" }
const _hoisted_25 = { class: "min-w-150px" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_27 = { class: "d-flex align-items-center" }
const _hoisted_28 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_29 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary fs-6"
}
const _hoisted_30 = { class: "text-dark fw-bolder fs-6 pe-0" }
const _hoisted_31 = { class: "col-xxl-4" }
const _hoisted_32 = { class: "row mb-5 mb-xl-8" }
const _hoisted_33 = { class: "card" }
const _hoisted_34 = { class: "row mb-5 mb-xl-8" }
const _hoisted_35 = { class: "card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_cmarks = _resolveComponent("cmarks")!
  const _component_GradeChart = _resolveComponent("GradeChart")!
  const _component_MaxminChart = _resolveComponent("MaxminChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t("notes.notes")), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter) = $event)),
                onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems())),
                class: "form-control form-control-solid w-200px ps-15",
                placeholder: _ctx.t('course.subject')
              }, null, 40, _hoisted_10), [
                [_vModelText, _ctx.filter]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.t("notes.trimester")), 1),
              _createVNode(_component_el_form_item, { prop: "matiere" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.targetData.trimestre,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.targetData.trimestre) = $event)),
                    placeholder: _ctx.t('notes.chooseTrimester'),
                    name: "matiere",
                    as: "select"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, { value: "" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t("notes.chooseTrimester")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_option, {
                        label: "Trimestre 1",
                        value: "1"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("1")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_option, {
                        label: "Trimestre 2",
                        value: "2"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("2")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_option, {
                        label: "Trimestre 3",
                        value: "3"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("3")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ]),
            (_ctx.targetData.trimestre)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("punishments.actions")), 1),
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_button, {
                      disabled: _ctx.disabledAccess,
                      type: "success",
                      icon: _ctx.Check,
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveAll()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("notes.saveAll")), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "icon"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
            : _createCommentVNode("", true),
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("table", _hoisted_21, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.t("course.subject")), 1),
                      _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.t("notes.note")), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtredSubjects, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _hoisted_26,
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("a", _hoisted_29, _toDisplayString(item.name), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_30, [
                          (_ctx.targetData.trimestre)
                            ? (_openBlock(), _createBlock(_component_cmarks, {
                                key: 0,
                                id: _ctx.student._id,
                                subject: item,
                                trimester: _ctx.targetData.trimestre,
                                mark: _ctx.getMark(item._id),
                                classroom: _ctx.classID,
                                ref_for: true,
                                ref: _ctx.addRef
                              }, null, 8, ["id", "subject", "trimester", "mark", "classroom"]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          (_ctx.updatedGrades)
            ? (_openBlock(), _createBlock(_component_GradeChart, {
                key: 0,
                "widget-classes": "card-xl-stretch mb-5 mb-xl-8",
                height: 300,
                title: _ctx.t('notes.gradeState'),
                description: _ctx.t('notes.stateTitle'),
                data: _ctx.grades
              }, null, 8, ["title", "description", "data"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          (_ctx.updatedGrades && _ctx.loadedMaxmin)
            ? (_openBlock(), _createBlock(_component_MaxminChart, {
                key: 0,
                "widget-classes": "card-xl-stretch mb-5 mb-xl-8",
                height: 300,
                title: _ctx.t('stats.studentGradePerformance'),
                description: _ctx.t('stats.studentGradePerformanceThisTrimester'),
                data: _ctx.grades,
                maxmin: _ctx.maxmin,
                subjects: _ctx.listSubject
              }, null, 8, ["title", "description", "data", "maxmin", "subjects"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}